import type { WorldTheme } from './theme';

/**
 * United States sky of world 2: New York (GDD §11.1, §14.2, issue #112). Steel grey and amber at dusk: a dark
 * steel sky, grey skyline silhouettes with a few amber-lit blocks and a suspension bridge in the distance. It is
 * activated at the border crossing (`border:crossed`, as the Miami sky of #97). The sky stays dark so that the
 * amber bills keep 3:1 against it and every pickup stays more saturated than the decoration (GDD §14.1).
 */

const NEW_YORK = {
  skyline: 0x5f6b7d,
  skylineSoft: 0x6b778a,
  block: 0x3f4856,
  blockDark: 0x353d4a,
  lit: 0xa88650,
  litDark: 0x8f7344,
  foreground: 0x2a3038,
  bridgeDeck: 0x7a8290,
  bridgeTower: 0x59606b,
} as const;

export const USA_NEW_YORK: WorldTheme = {
  id: 'usa-new-york',
  variant: 'new-york',
  sky: 0x4a5568,
  fog: { color: 0x5a6578, near: 40, far: 150 },
  ground: 0x3a4048,
  ceiling: 0xe6c88a,
  collidable: { column: 0x33d060, pickup: 0xe0a000 },
  lights: {
    hemisphere: { sky: 0xc8d0e0, ground: 0x3a3a40, intensity: 0.95 },
    sun: { color: 0xffc880, intensity: 1.6, position: [-8, 9, 12] },
  },
  layers: [
    { name: 'layer.far', colors: [NEW_YORK.skyline, NEW_YORK.skylineSoft], moduleWidth: 22, height: 12, baseY: 1, motif: 'buildings' },
    { name: 'layer.mid', colors: [NEW_YORK.block, NEW_YORK.blockDark, NEW_YORK.lit, NEW_YORK.litDark], moduleWidth: 14, height: 7, baseY: 1, motif: 'buildings' },
    { name: 'layer.foreground', colors: [NEW_YORK.foreground], moduleWidth: 10, height: 1.4, baseY: -0.6, motif: 'foreground', followCamera: true },
  ],
  bridge: { deck: NEW_YORK.bridgeDeck, tower: NEW_YORK.bridgeTower },
};
